import { action, thunk } from "easy-peasy";
import API from "API";

export const ACTION_TYPES = {
  FETCHING_GROUP_AUTHS: 1,
  GROUPS_AUTHS_FETCHED: 2,
  FETCHING_AUTHS: 3,
  CREATING_AUTH: 4,
  UPDATING_AUTH: 5,
  DELETING_AUTH: 6,
  AUTHS_FETCHED: 7,
  AUTH_CREATED: 8,
  AUTH_UPDATED: 9,
  AUTH_DELETED: 10,
  FETCHING_USER_GROUPS: 11,
  CREATING_USER_GROUP: 12,
  UPDATING_USER_GROUP: 13,
  DELETING_USER_GROUP: 14,
  USER_GROUPS_FETCHED: 15,
  USER_GROUP_CREATED: 16,
  USER_GROUP_UPDATED: 17,
  USER_GROUP_DELETED: 18,
  FETCHING_GROUP_AUTHS_BY_ID: 19,
  GROUP_AUTHS_FETCHED_BY_ID: 20,
  UPDATING_GROUP_AUTHS_BY_ID: 21,
  GROUP_AUTHS_UPDATED_BY_ID: 22,
  FETCHING_USER_GROUP_ITEMS: 23,
  CREATING_USER_GROUP_ITEMS: 24,
  UPDATING_USER_GROUP_ITEMS: 25,
  DELETING_USER_GROUP_ITEM: 26,
  USER_GROUP_ITEMS_FETCHED: 27,
  USER_GROUP_ITEM_CREATED: 28,
  USER_GROUP_ITEM_UPDATED: 29,
  USER_GROUP_ITEM_DELETED: 30,
  FETCHING_USERS: 31,
  CREATING_USER: 32,
  UPDATING_USER: 33,
  DELETING_USER: 34,
  SEARCHING_USERS: 35,
  LOCKING_USER: 36,
  UNLOCKING_USER: 37,
  CONFIRMING_USER: 38,
  SETTING_DELETED_USER: 39,
  REMOVING_DELETED_USER: 40,
  USERS_FETCHED: 41,
  USER_CREATED: 42,
  USER_UPDATED: 43,
  USER_DELETED: 44,
  USERS_SEARCHED: 45,
  USER_LOCKED: 46,
  USER_UNLOCKED: 47,
  USER_CONFIRMED: 48,
  USER_DELETED_SET: 49,
  USER_DELETED_REMOVED: 50,
  FETCHING_USER: 51,
  USER_FETCHED: 52,
  RESTORING_USER: 53,
  USER_RESTORED: 54,
  FINISHED: 998,
  FAILED: 999,
};

const UserStoreModel = {
  groupAuths: [],
  auths: [],
  userGroups: [],
  userGroupItems: [],
  users: [],
  user: {},
  process: null,
  error: null,
  showArchived: false,

  setProcess: action((state, payload) => {
    state.process = payload;
  }),

  setGroupAuthsData: action((state, payload) => {
    state.groupAuths = payload;
  }),

  updateGroupAuthData: action((state, payload) => {
    let index = state.groupAuths.findIndex((f) => f.id === payload.id);
    state.groupAuths[index] = payload;
  }),

  setAuthsData: action((state, payload) => {
    state.auths = payload;
  }),

  setUserGroupItemsData: action((state, payload) => {
    state.userGroupItems = payload;
  }),

  setUsersData: action((state, payload) => {
    state.users = payload;
  }),

  setUserGroupsData: action((state, payload) => {
    state.userGroups = payload;
  }),

  setUserData: action((state, payload) => {
    state.user = payload;
  }),

  setError: action((state, payload) => {
    state.error = payload;
    state.process = ACTION_TYPES.FAILED;
  }),

  setShowArchived: action((state, payload) => {
    state.showArchived = payload;
  }),

  getGroupAuths: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USER_AUTHS);

    try {
      const result = await API.get("groupauthorizations", payload);
      actions.setGroupAuthsData(result);
      actions.setProcess(ACTION_TYPES.USER_AUTHS_FETCHED);
    } catch (error) {
      console.error("Error while getGroupAuths -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getAuths: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_AUTHS);

    try {
      const result = await API.get("userauthorizations", payload);
      actions.setAuthsData(result);
      actions.setProcess(ACTION_TYPES.AUTHS_FETCHED);
    } catch (error) {
      console.error("Error while getAuths -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  createAuth: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.CREATING_AUTH);

    try {
      await API.post("userauthorizations", payload);
      actions.setProcess(ACTION_TYPES.AUTH_CREATED);
    } catch (error) {
      console.error("Error while createAuth -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  updateAuth: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UPDATING_AUTH);

    try {
      await API.put(`userauthorizations/${payload.id}`, payload);
      actions.setProcess(ACTION_TYPES.AUTH_UPDATED);
    } catch (error) {
      console.error("Error while updateAuth -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  deleteAuth: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.DELETING_AUTH);

    try {
      await API.delete(`userauthorizations/${payload.id}`);
      actions.setProcess(ACTION_TYPES.AUTH_DELETED);
    } catch (error) {
      console.error("Error while deleteAuth -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getUserGroups: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USER_GROUPS);

    try {
      const result = await API.get("usergroups");
      actions.setProcess(ACTION_TYPES.USER_GROUPS_FETCHED);
      actions.setUserGroupsData(result);
    } catch (error) {
      console.error("Error while getUserGroups -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  createUserGroup: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.CREATING_USER_GROUP);

    try {
      await API.post("usergroups", payload);
      actions.setProcess(ACTION_TYPES.USER_GROUP_CREATED);
    } catch (error) {
      console.error("Error while getUserGroups -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  updateUserGroup: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UPDATING_USER_GROUP);

    try {
      await API.put(`usergroups/${payload.id}`, payload);
      actions.setProcess(ACTION_TYPES.USER_GROUP_UPDATED);
    } catch (error) {
      console.error("Error while updateUserGroup -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  deleteUserGroup: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.DELETING_USER_GROUP);

    try {
      await API.delete(`usergroups/${payload.id}`);
      actions.setProcess(ACTION_TYPES.USER_GROUP_DELETED);
    } catch (error) {
      console.error("Error while deleteUserGroup -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getGroupAuthsbyGroupId: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_GROUP_AUTHS_BY_ID);

    try {
      const result = await API.get(
        `/usergroups/${payload.object.id}/authorizations`,
        payload.body
      );
      actions.setProcess(ACTION_TYPES.GROUP_AUTHS_FETCHED_BY_ID);
      actions.setGroupAuthsData(result);
    } catch (error) {
      console.error("Error while getGroupAuthsbyGroupId -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  updateGroupAuthbyGroupId: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UPDATING_GROUP_AUTHS_BY_ID);

    try {
      await API.put(
        `/usergroups/${payload.object.id}/authorizations`,
        payload.body
      );
      actions.setProcess(ACTION_TYPES.GROUP_AUTHS_UPDATED_BY_ID);
    } catch (error) {
      console.error("Error while getGroupAuthsbyGroupId -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getUserGroupItems: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USER_GROUP_ITEMS);

    try {
      const result = await API.get(`/usergroups/${payload.object.id}/items`);
      actions.setProcess(ACTION_TYPES.USER_GROUP_ITEMS_FETCHED);
      actions.setUserGroupItemsData(result);
    } catch (error) {
      console.error("Error while getGroupAuthsbyGroupId -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  createUserGroupItem: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.CREATING_USER_GROUP_ITEMS);

    try {
      await API.post(`/usergroups/${payload.object.id}/items`, payload);
      actions.setProcess(ACTION_TYPES.USER_GROUP_ITEMS_CREATED);
    } catch (error) {
      console.error("Error while createUserGroupItem -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  updateUserGroupItem: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UPDATING_USER_GROUP_ITEMS);

    try {
      await API.put(`/usergroups/${payload.object.id}/items`, payload.body);
      actions.setProcess(ACTION_TYPES.USER_GROUP_ITEMS_UPDATED);
    } catch (error) {
      console.error("Error while updateUserGroupItem -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  deleteUserGroupItem: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.DELETING_USER_GROUP_ITEM);

    try {
      await API.delete(
        `/usergroups/${payload.object.parent.id}/items/${payload.object.id}`
      );
      actions.setProcess(ACTION_TYPES.USER_GROUP_ITEM_DELETED);
    } catch (error) {
      console.error("Error while deleteUserGroupItem -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getUsers: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USERS);

    try {
      const result = await API.get(`/users/all`);
      actions.setProcess(ACTION_TYPES.USERS_FETCHED);
      actions.setUsersData(result);
    } catch (error) {
      console.error("Error while getUsers -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  searchUsers: thunk(async (actions, payload, { getState, getStoreState }) => {
    actions.setProcess(ACTION_TYPES.SEARCHING_USERS);

    try {
      const state = getState();
      let params = state.showArchived
        ? { params: { ...payload, state: "DELETED" } }
        : { params: { ...payload, state: "ACTIVE" } };

      const result = await API.get(`/users/search`, params);
      actions.setProcess(ACTION_TYPES.USERS_SEARCHED);
      actions.setUsersData(result);
    } catch (error) {
      console.error("Error while searchUsers -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  createUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.CREATING_USER);

    try {
      const response = await API.post(`/users`, payload);
      actions.setProcess(ACTION_TYPES.USER_CREATED);
      actions.setUserData(response);
    } catch (error) {
      console.error("Error while createUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  getUserById: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USER);

    try {
      const result = await API.get(`/users/${payload.object.id}`);
      actions.setProcess(ACTION_TYPES.USER_FETCHED);
      actions.setUserData(result);
    } catch (error) {
      console.error("Error while getUserById -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  updateUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UPDATING_USER);

    try {
      await API.put(`/users/${payload.id}`, payload);
      actions.setProcess(ACTION_TYPES.USER_UPDATED);
    } catch (error) {
      console.error("Error while updateUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  deleteUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.DELETING_USER);

    try {
      await API.delete(`/users/${payload.id}`, {
        params: payload,
      });
      actions.setProcess(ACTION_TYPES.USER_DELETED);
    } catch (error) {
      console.error("Error while deleteUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  confirmUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.CONFIRMING_USER);

    try {
      await API.put(`/users/${payload.id}/confirmUser`);
      actions.setProcess(ACTION_TYPES.USER_CONFIRMED);
    } catch (error) {
      console.error("Error while deleteUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  lockUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.LOCKING_USER);

    try {
      await API.put(`/users/${payload.id}/lockUser`);
      actions.setProcess(ACTION_TYPES.USER_LOCKED);
    } catch (error) {
      console.error("Error while lockUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  unLockUser: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.UNLOCKING_USER);

    try {
      await API.put(`/users/${payload.id}/unLockUser`);
      actions.setProcess(ACTION_TYPES.USER_UNLOCKED);
    } catch (error) {
      console.error("Error while unLockUser -> ", error);
      actions.setError(error);
    }

    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  restoreUser: thunk(async (actions, payload) => {
    actions.setProcess(ACTION_TYPES.RESTORING_USER);
    try {
      const result = await API.put(`/users/${payload.id}/returnArchive`, null, {
        params: payload,
      });
      actions.setProcess(ACTION_TYPES.USER_RESTORED);
      actions.setResponse(result);
      return result;
    } catch (error) {
      console.error("Error while updating data -> ", error);
      actions.setError(error);
    }
    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  fetchDeletedRecords: thunk(async (actions, payload) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USERS);
    try {
      const data = await API.get(`/users/deletedrecords`);
      actions.setUsersData(data);
      actions.setProcess(ACTION_TYPES.USERS_FETCHED);
      return data;
    } catch (error) {
      console.error("Error while creating data -> ", error);
      actions.setError(error);
    }
    actions.setProcess(ACTION_TYPES.FINISHED);
  }),

  fetchDeletedRecord: thunk(async (actions, payload) => {
    actions.setProcess(ACTION_TYPES.FETCHING_USER);
    try {
      const data = await API.get(`/users/deletedrecords/${payload.id}`);
      actions.setUserData(data);
      actions.setProcess(ACTION_TYPES.USER_FETCHED);
      return data;
    } catch (error) {
      console.error("Error while creating data -> ", error);
      actions.setError(error);
    }
    actions.setProcess(ACTION_TYPES.FINISHED);
  }),
};

export default UserStoreModel;
